import * as types from '../constants/actionTypes';

export function createCustomerGroupProject({status, data} = {}) {
    return {
        type: types.CREATE_CUSTOMER_GROUP_PROJECT
        , status
        , data
    };
}

export function deleteCustomerGroupProject({status, data} = {}) {
    return {
        type: types.DELETE_CUSTOMER_GROUP_PROJECT
        , status
        , data
    };
}

export function loadCustomerGroups({status, data} = {}) {
    return {
        type: types.LOAD_CUSTOMER_GROUPS
        , status
        , data
    };
}

export function loadCustomerGroupsByProject({status, data} = {}) {
    return {
        type: types.LOAD_CUSTOMER_GROUPS_BY_PROJECT
        , status
        , data
    };
}

export function saveCustomerGroup({status, data} = {}) {
    return {
        type: types.SAVE_CUSTOMER_GROUP
        , status
        , data
    };
}

export function setLoadingFlagForCustomerGroupState() {
    return { type: types.SET_LOADING_FLAG_FOR_CUSTOMER_GROUP_STATE };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/customerGroupActions.js
 **/